import { CalendarDays } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import Reveal from "@/components/Reveal";

const Fresque = () => {
  const { t } = useLang();
  const entries = t.fresque.entries;
  const lastIndex = entries.length - 1;

  return (
    <section id="fresque" data-testid="fresque-section" className="relative border-y border-gold/15 bg-ink2">
      <div className="mx-auto max-w-[1600px] px-4 py-24 sm:px-8 lg:px-16 lg:py-36">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-gold">{t.fresque.kicker}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 max-w-3xl font-serif text-3xl font-light leading-tight text-parchment sm:text-4xl lg:text-5xl">
            {t.fresque.title}
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-sand sm:text-lg">{t.fresque.sub}</p>
        </Reveal>

        <div className="mt-16 space-y-0">
          {entries.map((entry, i) => {
            const isLast = i === lastIndex;
            const done = Boolean(entry.image);
            return (
              <Reveal key={entry.date} delay={0.05}>
                <article
                  data-testid="fresque-entry"
                  className={`group grid grid-cols-1 items-center gap-6 py-10 lg:grid-cols-12 lg:gap-10 ${
                    isLast
                      ? "my-8 border border-gold/40 bg-card2 px-6 sm:px-10"
                      : "border-t border-gold/15"
                  }`}
                >
                  <div className="lg:col-span-3">
                    <p className={`flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] ${done ? "text-gold" : "text-sand/70"}`}>
                      <CalendarDays size={13} />
                      {entry.date}
                    </p>
                    {!done && !isLast && (
                      <span className="mt-3 inline-block rounded-full border border-dashed border-gold/40 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.25em] text-gold/80">
                        {t.fresque.upcoming}
                      </span>
                    )}
                  </div>
                  <div className={entry.image ? "lg:col-span-6" : "lg:col-span-9"}>
                    <h3 className={`font-serif font-light text-parchment transition-colors duration-300 group-hover:text-goldlight ${isLast ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>
                      {entry.title}
                    </h3>
                    <p className="mt-3 max-w-xl text-sm font-light leading-relaxed text-sand sm:text-base">
                      {entry.text}
                    </p>
                    {isLast && (
                      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-gold/80">
                        {t.fresque.blessing_note}
                      </p>
                    )}
                  </div>
                  {entry.image && (
                    <div className="lg:col-span-3">
                      <div className="gold-frame relative h-44 overflow-hidden border border-gold/20">
                        <img
                          src={entry.image}
                          alt={entry.title}
                          loading="lazy"
                          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                        />
                      </div>
                    </div>
                  )}
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Fresque;
